import { useState } from "react";
import { Menu, X, CalendarCheck } from "lucide-react";

const links = [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Why Choose Us", href: "#why-us" },
    { label: "Reviews", href: "#reviews" },
    { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="fixed top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
                <a href="#home" data-testid="nav-logo-link" className="flex items-center gap-2.5 group">
                    <span className="h-10 w-10 rounded-xl bg-teal-600 flex items-center justify-center shadow-[0_6px_16px_rgba(13,148,136,0.3)] transition-transform duration-300 group-hover:scale-105">
                        <svg viewBox="0 0 24 24" className="h-5 w-5 text-white" fill="currentColor" aria-hidden="true">
                            <path d="M12 2C8.5 2 6 4.2 6 7.5c0 2.4.9 4.1 1.5 6.2.6 2.2.9 4.6 1.4 6.6.2.9 1.5.9 1.8-.1.4-1.5.7-4.2 1.3-4.2s.9 2.7 1.3 4.2c.3 1 1.6 1 1.8.1.5-2 .8-4.4 1.4-6.6.6-2.1 1.5-3.8 1.5-6.2C18 4.2 15.5 2 12 2z" />
                        </svg>
                    </span>
                    <span className="leading-tight">
                        <span className="block font-semibold text-slate-900 text-[15px] font-heading">The Tooth Care</span>
                        <span className="block text-[11px] font-semibold uppercase tracking-[0.18em] text-teal-600">Dental Clinic</span>
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-teal-600"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href="#appointment"
                        data-testid="nav-book-appointment-btn"
                        className="hidden sm:inline-flex items-center gap-2 rounded-full bg-teal-600 px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_20px_rgba(13,148,136,0.35)] transition-colors duration-200 hover:bg-teal-700"
                    >
                        <CalendarCheck className="h-4 w-4" strokeWidth={2} />
                        Book Appointment
                    </a>
                    <button
                        type="button"
                        data-testid="nav-mobile-menu-btn"
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 text-slate-700 transition-colors duration-200 hover:bg-slate-50"
                        aria-label="Toggle menu"
                        aria-expanded={open}
                    >
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-slate-100 bg-white shadow-[0_10px_40px_rgb(0,0,0,0.08)]" data-testid="nav-mobile-menu">
                    <nav className="px-4 py-4 flex flex-col gap-1" aria-label="Mobile">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                onClick={() => setOpen(false)}
                                className="rounded-xl px-4 py-3 text-sm font-medium text-slate-700 transition-colors duration-200 hover:bg-teal-50 hover:text-teal-700"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#appointment"
                            data-testid="mobile-nav-book-appointment-btn"
                            onClick={() => setOpen(false)}
                            className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-teal-600 px-5 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-teal-700"
                        >
                            <CalendarCheck className="h-4 w-4" />
                            Book Appointment
                        </a>
                    </nav>
                </div>
            )}
        </header>
    );
};
